module.exports = __webpack_public_path__ + "4b869d088539b68043cf9de0e673b66f.pdf";